module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-06.df1d4a58.jpeg";